import { AVAILABLE_COUNTRIES_REGISTRATION } from '@constants';

export type CountryKey = Lowercase<(typeof AVAILABLE_COUNTRIES_REGISTRATION)[number]['value']>;

export const getCurrentCountry = () => {
  const tld = window.location.hostname.split('.').pop()?.toLowerCase() as CountryKey;
  return AVAILABLE_COUNTRIES_REGISTRATION.find(c => c.value.toLowerCase() === tld) ?? AVAILABLE_COUNTRIES_REGISTRATION[0];
};
